import React, { Fragment } from 'react';
import { Flex } from 'antd';
import { integrationMetricList } from 'modules/DashboardModule/charts/components/IntegrationMetricList';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';
import getFormattedValue from 'store/redux/utils/getFormattedValue';
import { networksMetrics } from './networksMetrics';

const ChannelsTooltip = ({ payload, label, selected_metrics }) => {
  const values = payload?.[0]?.payload?.[selected_metrics];

  const { valueFormatter, formatter } = integrationMetricList[selected_metrics] || {};
  const ValueFormatter = valueFormatter || Fragment;
  const FormatterComponent = formatter || Fragment;

  if (!values) return null;

  return (
    <div
      className='shadow-md rounded-md p-2'
      style={{
        background: 'rgba(255,255,255,0.9)',
      }}
    >
      <div className='font-semibold text-sm mb-2 flex justify-center'>
        {new Date(label).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        })}
      </div>
      {Object.entries(values).map(([networkKey, value]) => {
        const network = networksMetrics[networkKey];
        if (!network) return null;

        const { symbol, currency } = integrationMetricList[selected_metrics] || {};

        let formattedValue = network.label;
        if (symbol) {
          formattedValue = `${getFormattedNumber(value)}${symbol}`;
        } else if (currency) {
          formattedValue = getFormattedValue(value);
        }

        return (
          <Flex align='center' gap='middle' key={networkKey} justify='space-between'>
            <Flex align='center' gap='small'>
              <img src={network.icon} alt={network.label} width={16} height={16} />
              <span>{network.label}</span>
            </Flex>
            <span className='text-md !font-medium'>
              {valueFormatter ? (
                <ValueFormatter value={value} />
              ) : formatter ? (
                <FormatterComponent row={{ [selected_metrics]: value }} fontWeight='medium' />
              ) : (
                formattedValue
              )}
            </span>
          </Flex>
        );
      })}
    </div>
  );
};

export default ChannelsTooltip;
